import { useEffect, useState } from "react";
import apiClient from "utils/apiClient";
import { ENDPOINTS } from "utils/endpoints";

const useUserStats = (token) => {
  const [weeklyStreak, setWeeklyStreak] = useState(0);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await apiClient.get(ENDPOINTS.users.stats);
        setWeeklyStreak(res.data.streak || 0);
      } catch (error) {
        console.error("Error fetching user stats:", error.message);
      }
    };

    if (token) fetchStats();
  }, [token]);

  return weeklyStreak;
};

export default useUserStats;
